import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";

export const PayoutCalculationIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Payouts for brands on Faire are calculated using the following formula: Payout amount = (order subtotal) + (shipping reimbursement) - (commission) - (payment processing fee)"
          description={{
            img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ul>
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Order subtotal</BoldFormatting>: Cumulative wholesale cost of the items in the order, minus any brand-funded promotions."
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
              }}
            />
          </Typography>
        </RowWithBullet>
        <Spacer height="1x" />
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Shipping reimbursement</BoldFormatting>: The cost of shipping (only applies when the order is fulfilled on your own, not using Ship with Faire)"
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
              }}
            />
          </Typography>
        </RowWithBullet>
        <Spacer height="1x" />
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Commission</BoldFormatting>: Order subtotal x commission rate for that order"
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
              }}
            />
          </Typography>
        </RowWithBullet>
        <Spacer height="1x" />
        <RowWithBullet>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Payment processing fee</BoldFormatting>: Item subtotal x payment processing fee"
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
              }}
            />
          </Typography>
        </RowWithBullet>
      </ul>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can see a full calculation of your payout under your <BoldFormatting>Orders</BoldFormatting> tab by clicking on the order’s detail page. Scroll to the <BoldFormatting>You got paid!</BoldFormatting> section and select <BoldFormatting>View Payout Summary</BoldFormatting>. There you will find a detailed breakdown of the payout."
          description={{
            img: "https://cdn.faire.com/fastly/fb424e0879888200f55a2c2a492ba9733ae7a7c70ac8730a206e6e5967790051.png",
          }}
          values={{
            BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
          }}
        />
      </Typography>
    </Column>
  );
};

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
